import { Routes } from '@angular/router';
import { AdminLayoutComponent } from './layout/admin-layout.component';
import { LoginComponent } from './pages/login/login.component';
import { PasswordResetComponent } from './pages/password-reset/password-reset.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { EmployersComponent } from './pages/employers/employers.component';
import { EmployerDetailComponent } from './pages/employers/employer-detail.component';
import { AdminUsersComponent } from './pages/admin-users/admin-users.component';
import { LoanConfigComponent } from './pages/loan-config/loan-config.component';
import { FundPoolComponent } from './pages/fund-pool/fund-pool.component';
import { adminAuthGuard } from './core/auth.guard';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'password-reset', component: PasswordResetComponent },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [adminAuthGuard],
    canActivateChild: [adminAuthGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      { path: 'dashboard', component: DashboardComponent },
      { path: 'employers', component: EmployersComponent },
      { path: 'employers/:id', component: EmployerDetailComponent },
      { path: 'loan-config', component: LoanConfigComponent },
      { path: 'fund-pool', component: FundPoolComponent },
      { path: 'admin-users', component: AdminUsersComponent }
    ]
  },
  { path: '**', redirectTo: 'dashboard' }
];
